// src/layouts/admin/index.js
import { Box, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, FormControl, FormLabel, Input, useToast } from "@chakra-ui/react";
import Footer from "components/footer/FooterAdmin";
import TopMenuBar from "components/navbar/TopMenuBar";
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { adminRoutes } from "routes";
import { changePassword } from "../../services/auth";

export default function Dashboard() {
  const toast = useToast();
  const [forceOpen, setForceOpen] = React.useState(() => localStorage.getItem("requiresPasswordChange") === "true");
  const [newPassword, setNewPassword] = React.useState("");
  const [newPassword2, setNewPassword2] = React.useState("");
  const [saving, setSaving] = React.useState(false);

  const onSubmitChange = async () => {
    try {
      setSaving(true);
      await changePassword({ newPassword, newPassword2 });
      toast({ status: "success", title: "비밀번호가 변경되었습니다." });
      setForceOpen(false);
      localStorage.removeItem("requiresPasswordChange");
      setNewPassword(""); setNewPassword2("");
    } catch (e) {
      const msg = e?.response?.data?.detail || e?.message || "변경에 실패했습니다.";
      toast({ status: "error", title: String(msg) });
    } finally { setSaving(false); }
  };

  return (
    <Box>
      {/*  상단 메뉴바 */}
      <TopMenuBar />

      {/*  메인 컨텐츠 (상단바 높이만큼 padding 추가) */}
      <Box as="main" pt="60px" px="20px">
<Routes>
  {adminRoutes.map((route, idx) => (
    <Route key={idx} path={route.path} element={route.element} />
  ))}

  {/* 기본 admin 경로 */}
  <Route index element={<Navigate to="prediction" replace />} />

  {/* 잘못된 경로 */}
  <Route path="*" element={<Navigate to="prediction" replace />} />
</Routes>
      </Box>

      <Footer />

      {/* 강제 비밀번호 변경 모달 */}
      <Modal isOpen={forceOpen} onClose={() => {}} isCentered closeOnOverlayClick={false} closeOnEsc={false}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>비밀번호 변경이 필요합니다</ModalHeader>
          <ModalBody>
            <FormControl mb="12px">
              <FormLabel>새 비밀번호</FormLabel>
              <Input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
            </FormControl>
            <FormControl>
              <FormLabel>새 비밀번호 확인</FormLabel>
              <Input type="password" value={newPassword2} onChange={(e) => setNewPassword2(e.target.value)} />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onSubmitChange} isLoading={saving}>
              변경하기
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
}
